import { createQuery } from '@tanstack/svelte-query';
import { QUERY_KEY_CREATOR_CURATED_PAGES } from '../constants';

const getCreatorCuratedPages = async () => {
  const response = await fetch(`/api/curated/page/list`);
  const data = await response.json();
  return data.objects;
};

export const queryCreatorCuratedPages = (queryOptions) =>
  createQuery({
    queryKey: [QUERY_KEY_CREATOR_CURATED_PAGES],
    queryFn: () => getCreatorCuratedPages(),
    refetchOnWindowFocus: false,
    retry: false,
    ...queryOptions,
  });
